import { useRef, useState } from "react";
import { SwitchTransition, Transition } from "react-transition-group";
import NavBar from "@shared/v2/NavBar";
import Nav from "@shared/v2/Nav";
import PhoneSystem from "./PhoneSystem";
import getTransitionStyles from "./utils/getTransitionStyles";
import Opportunities from "./Opportunities";

enum PlansTabs {
  PhoneSystem = "Phone System",
  Opportunities = "Opportunities",
}

const TABS = {
  [PlansTabs.PhoneSystem]: PhoneSystem,
  [PlansTabs.Opportunities]: Opportunities,
};

const Plans = ({ portalUrl }: { portalUrl: string }) => {
  const [tab, setTab] = useState(PlansTabs.PhoneSystem);
  const directionRef = useRef<"up" | "down">("down");
  const tabRefs = {
    [PlansTabs.PhoneSystem]: useRef<HTMLDivElement | null>(null),
    [PlansTabs.Opportunities]: useRef<HTMLDivElement | null>(null),
  };

  const handleTabChange = (newTab: PlansTabs) => {
    if (newTab === tab) return;
    const PlansTabsValues = Object.values(PlansTabs);
    const currentIndex = PlansTabsValues.indexOf(tab);
    const newIndex = PlansTabsValues.indexOf(newTab);
    const isMovingDown = newIndex > currentIndex;
    directionRef.current = isMovingDown ? "down" : "up";
    setTab(newTab);
  };

  const ActiveTab = TABS[tab];

  return (
    <div className="tw-py-[16px] tw-flex tw-gap-[32px]">
      <NavBar className="tw-min-h-[300px]">
        {/* @ts-expect-error props */}
        <Nav
          selected={tab === PlansTabs.PhoneSystem}
          size="medium"
          label="Phone System"
          onClick={() => handleTabChange(PlansTabs.PhoneSystem)}
        />
        {/* @ts-expect-error props */}
        <Nav
          selected={tab === PlansTabs.Opportunities}
          size="medium"
          label="Opportunities"
          onClick={() => handleTabChange(PlansTabs.Opportunities)}
        />
      </NavBar>
      <div className="tw-flex-1 tw-overflow-y-hidden">
        <SwitchTransition mode="out-in">
          <Transition
            key={tab}
            nodeRef={tabRefs[tab]}
            timeout={200}
            onEnter={() =>
              // Force reflow before entering transition starts
              tabRefs[tab].current?.offsetHeight
            }
          >
            {(state) => (
              <div ref={tabRefs[tab]} style={getTransitionStyles(state, directionRef.current)}>
                <ActiveTab portalUrl={portalUrl} />
              </div>
            )}
          </Transition>
        </SwitchTransition>
      </div>
    </div>
  );
};

export default Plans;
